var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 417",
    style: {
      enableBackground: "new 0 0 256 417"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#343434;}\n\t.st1{fill:#8C8C8C;}\n\t.st2{fill:#3C3C3B;}\n\t.st3{fill:#141414;}\n\t.st4{fill:#393939;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "127.96,0 125.17,9.5 125.17,285.17 127.96,287.96 255.92,212.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.96,0 0,212.32 127.96,287.96 127.96,154.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "127.96,312.19 126.39,314.11 126.39,412.31 127.96,416.91 256,236.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.96,416.91 127.96,312.19 0,236.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "127.96,287.96 255.92,212.32 127.96,154.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "0,212.32 127.96,287.96 127.96,154.16  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth_icon.1138d1528cb670cbb93a03ea4de40b16.svg";
export { ForwardRef as ReactComponent };